export enum FilterUserType {
  ADMIN = 'admin',
  SDR = 'sdr',
  AGENT = 'agent',
  NOT_DELETED = 'not_deleted',
  DELETED = 'deleted',
}
